module.exports = __webpack_public_path__ + "static/oplata-ffd3bb82b79af36dab221c9b782f4aec.png";